import * as React from "react";

import styled from "../../theme/styled";
import {
  colourHelper,
  fontLineHeightHelper,
  fontSizeHelper,
  fontWeightHelper
} from "../../theme/theme-helper";
import {
  HalfColumnWidthWrapper,
  SmallColumnWidthWrapper
} from "../confines-wrappers";
import Wysiwyg from "../wysiwyg";
import { IFieldTechnicalArticleColumnType } from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content?: string;
}

interface ISummaryWrapper {
  type: IFieldTechnicalArticleColumnType;
}

const SummaryWrapper = styled<ISummaryWrapper, "aside">("aside")`
  padding-top: 4.4rem;
  padding-bottom: 2%;

  h2,
  h3,
  h4,
  p,
  ul,
  ol {
    margin: 0;
    padding: 0;
  }

  .hr {
    display: block;
    padding-top: 10%;

    span {
      display: block;
      height: 0.2rem;
      background-color: ${({ theme }) =>
    colourHelper({
      theme,
      variant: "lightestGrey"
    })};
    }
  }

  h2,
  h3,
  h4 {
    padding-top: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "default"
    })};
    font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "subhead_1"
    })};
    font-weight: ${({ theme }) =>
    fontWeightHelper({
      theme,
      variant: "heavy"
    })};
  }

  h2 {
    font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "subhead_1"
    })};
  }

  h3 {
    font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "body_2"
  })};
  }

  h4 {
    font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "body_1"
  })};
  }

  p,
  ul,
  ol {
    padding-top: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "default"
    })};
    font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "body_1"
  })};
    font-weight: ${({ theme }) =>
    fontWeightHelper({
      theme,
      variant: "light"
    })};
    line-height: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "default"
    })};

    strong {
      font-weight: ${({ theme }) =>
    fontWeightHelper({
      theme,
      variant: "heavy"
    })};
    }
  }

  ul,
  ol {
    padding-left: 2.8rem;
  }

  *:first-child {
    padding-top: 0;
  }

  @media (min-width: 600px) {
    padding-bottom: 2rem;

    .hr {
      padding-top: 5.8rem;
    }
  }

  @media (min-width: 960px) {
    padding-bottom: 0.4rem;
  }
`;

const Summary = ({ type, content }: IProps) => {
  if (!content) {
    return null;
  }

  return (
    <SummaryWrapper type={type}>
      <HalfColumnWidthWrapper>
        <h2>
          In Summary
        </h2>

        <Wysiwyg
          type="formatted"
          content={content}
        />
      </HalfColumnWidthWrapper>

      <SmallColumnWidthWrapper
        tagName="span"
        className="hr"
      >
        <span />
      </SmallColumnWidthWrapper>
    </SummaryWrapper>
  );
};

export default Summary;
